/**
 * Zet een afbeeldings-URL uit de spreadsheet om naar een URL die de browser
 * daadwerkelijk als afbeelding kan laden.
 *
 * Google Drive share-links (bijv. https://drive.google.com/open?id=...) serveren
 * een HTML-pagina in plaats van de afbeelding zelf; die worden herschreven naar
 * lh3.googleusercontent.com, dat de ruwe afbeelding serveert.
 */
export function resolveImageUrl(url: string | undefined, fallback: string): string {
  if (!url || typeof url !== 'string' || url.trim() === '') {
    return fallback;
  }

  try {
    let processedUrl = url.trim();

    if (processedUrl.startsWith('/images/')) {
      return processedUrl;
    }

    if (processedUrl.includes('drive.google.com') || processedUrl.includes('docs.google.com')) {
      // Probeer het bestands-ID te extraheren: uit ?id=... of uit /d/.../
      let id = '';
      const idMatch = processedUrl.match(/[?&]id=([^&]+)/);
      if (idMatch) {
        id = idMatch[1];
      } else {
        const dMatch = processedUrl.match(/\/d\/([^/]+)/);
        if (dMatch) {
          id = dMatch[1];
        }
      }

      if (id) {
        // Fix voor potentiele spaties in ID (soms worden underscores spaties in data transfer)
        id = id.trim().replace(/\s/g, '_');
        return `https://lh3.googleusercontent.com/d/${id}`;
      }

      if (!processedUrl.startsWith('http')) {
        processedUrl = `https://${processedUrl}`;
      }
      return processedUrl;
    }

    if (processedUrl.startsWith('http://') || processedUrl.startsWith('https://')) {
      return processedUrl;
    }

    if (processedUrl.startsWith('www.')) {
      return `https://${processedUrl}`;
    }

    // Anders, bouw een relatieve URL op naar de images folder
    const cleanUrl = processedUrl.replace(/^\/*/, '');
    return `/images/${cleanUrl}`;
  } catch (error) {
    console.error('Error processing image URL:', error);
    return fallback;
  }
}
